<template>

  <div id="wrapper">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <h3 class="font-light m-b-xs" v-if="question">
            <template v-if="question.project.workflow_id === 3">
              Received tech Offer - <span class="font-bold text-info">{{question.title}}</span>
            </template>
            <template v-else>
              Received Question - <span class="font-bold text-info">{{question.title}}</span>
            </template>
          </h3>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="hpanel">
        <div class="panel-body">
          <div class="row" v-if="question">

            <div class="col-xs-12">
              <div v-if="question.picture" class="col-md-3">
                <img :src="$apiUrl + question.picture" style="max-width: 100%"/>
              </div>
              <div :class="question.picture !== null ? 'col-md-9' : 'col-md-12'">
                <div>
                  <label>Overview</label>
                  <div>
                    <template v-if="question.company_profile">{{question.company_profile}}</template>
                    <template>{{question.objective}}</template> <br>
                    <template v-if="question.issue">{{question.issue}}</template>
                    <template v-if="question.restraint">{{question.restraint}}</template>
                    <template v-if="question.expert_interest"><br>{{question.expert_interest}}</template>
                  </div>
                </div>
              </div>
              <div class="col-xs-12" style="margin-top: 15px">
                <label>Details</label>
                <div v-html="question.long_description"></div>
              </div>

              <div class="col-xs-12" v-if="question.files.length !== 0">
                <label>Files</label>
                <div>
                  <a v-for="(file, key) in question.files" :key="key" :href="api_url + file.filename" target="_blank" class="col-xs-3">{{file.filename.replace(/^.*[\\\/]/, '')}}</a>
                </div>
              </div>

              <div class="col-md-6" style="margin-top: 15px">
                <div>
                  <label>Maturity level</label>
                  <div v-if="question.trl">{{question.trl.name}}</div>

                </div>

                <div style="margin-top: 15px">
                  <label>Timeline</label>
                  <div v-if="question.timeline">{{question.timeline.name}}</div>

                </div>

                <div style="margin-top: 15px">
                  <label>Intellectual Property Rights</label>
                  <div v-for="(maturity, key) in question.maturities" :key="key">{{maturity.name}}</div>

                </div>

                <div style="margin-top: 15px" v-if="question.project.workflow_id !== 3">
                  <label>Expected proposal</label>
                  <div v-for="(proposalRequest, key) in question.proposal_requests" :key="key" v-html="proposalRequest.label"></div>
                </div>
              </div>

              <div class="col-md-6" style="margin-top: 15px" v-if="question.metrics.length">
                <label>Measurable performance</label>
                <table cellpadding="1" cellspacing="1" class="table table-condensed table-striped">
                  <thead>
                  <tr>
                    <th>Criteria</th>
                    <th>Common figure (SoA)</th>
                    <th>Target</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(metric, key) in question.metrics" :key="key">
                    <td>{{metric.name}}</td>
                    <td>{{metric.current}}</td>
                    <td>{{metric.target}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

            </div>

          </div>
        </div>
      </div>
      <div class="row text-center">
        <router-link v-if="expertExist" class="btn btn-info" :to="{name: 'LoginExpert', params: infoUser}">Propose a response</router-link>
        <router-link v-else-if="!expertExist" class="btn btn-info" :to="{name: 'RegisterExpert', params: infoUser}">Propose a response</router-link>
      </div>

    </div>
  </div>

</template>

<style>
  body.light-skin #header {
    background-color: #fff !important;
  }
</style>
<script>
import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  props: [],
  name: 'QuestionExpertPreview',
  methods: {
    getResources: function () {
      this.axios.get('/expert/token/' + this.token + '?relations={mailing,mailing.question,mailing.question.maturities,' +
          'mailing.question.maturities,mailing.question.proposalRequests,mailing.question.trl,' +
          'mailing.question.timeline,mailing.question.files,mailing.question.metrics,mailing.question.nbResponse,' +
          'mailing.question.excludeCountry,mailing.question.preferredCountry,mailing.question.consultant.profile,' +
          'mailing.question.project}')
        .then((response) => {
          let mailingAuthor = response.data
          this.question = mailingAuthor.mailing.question
          $('#logo img').attr('src', this.$apiUrl + this.question.consultant.profile.logo)

          if (this.question.consultant.profile_id === 2) {
            $('#navigation-publicQuestion').attr('href', process.env.WEBSITE_URL + '/crop-public-questions')
          }

          if (typeof mailingAuthor.email !== 'undefined') {
            this.axios.post('user/exist', {email: mailingAuthor.email}).then((response) => {
              this.expertExist = true
            }).catch((error) => {
              this.expertExist = false
            })

            this.infoUser = {
              email: mailingAuthor.email,
              firstName: mailingAuthor.author.firstName,
              lastName: mailingAuthor.author.lastName,
              registerType: 'Individual'
            }
          }
        }).catch(function (error) {
        })
    }
  },
  watch: {
  },
  data () {
    return {
      token: null,
      question: null,
      infoUser: {},
      expertExist: false,
      api_url: process.env.API_URL
    }
  },
  mounted () {
  },
  beforeMount () {
    this.token = this.$route.params.token
    this.$localStorage.set('expert_token', this.token)

    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/expert/QuestionExpertPreview.vue